// extracted by mini-css-extract-plugin
export default {"wrapper":"Py-z","button":"Qy-z","alternate":"Ry-z","disabled":"Sy-z","paymentWarning":"Ty-z","fadeIn":"Uy-z"};